import { useFieldArray, useFormContext } from "react-hook-form";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Input,
  useTheme,
} from "@mui/material";
import { VRSTA_ZAHTJEVA } from "../../../../enums";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { PorukaGreskePolja } from "../../../index";
import { ChangeEvent, useState } from "react";

const Index = (props: any) => {
  const { register, getValues } = useFormContext();
  const { fields, append, remove } = useFieldArray({ name: "kategorije" });
  const vrstaZahtjeva = getValues("vrstaZahtjeva");
  const iskljucenje = getValues("iskljucenje");
  const [prikaziOpisOkolnosti, setPrikaziOpisOkolnosti] = useState(false);
  const theme = useTheme();

  if (vrstaZahtjeva === VRSTA_ZAHTJEVA.REGISTRACIJA) return null;

  const handleChange = (e: ChangeEvent<HTMLInputElement>, id: number) => {
    if (parseInt(e.target.value) === -1) {
      setPrikaziOpisOkolnosti(e.target.checked);
    }
  };

  return (
    <Grid item xs={12} sx={{ mt: 3 }}>
      <FormControl variant="standard">
        <h5>
          *Operatera platforme koriste samo isključeni prodavatelji sljedećih
          kategorija: (Platform Operator used only by Excluded Sellers of the
          following categories:)
        </h5>
        <FormGroup>
          {iskljucenje.map((item: any, key: number) => (
            <FormControlLabel
              key={key}
              control={
                <Checkbox
                  value={item.id}
                  {...register(`kategorije[${key}].id`)}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleChange(e, item.id)
                  }
                />
              }
              label={item.opis}
              style={{ marginBottom: 15 }}
            />
          ))}
        </FormGroup>
      </FormControl>
      <PorukaGreskePolja nazivPolja={"kategorije"} />
      {prikaziOpisOkolnosti && (
        <>
          <FormControl fullWidth error={!daLiJePoljeValidno("opisOkolnosti")}>
            <Input
              multiline
              rows={4}
              {...register("opisOkolnosti")}
              style={{ border: `1px solid ${theme.palette.text.disabled}` }}
            />
          </FormControl>
          <PorukaGreskePolja nazivPolja={"opisOkolnosti"} />
        </>
      )}
    </Grid>
  );
};

export default Index;
